module.exports = __webpack_public_path__ + "img/background040.80de804c.jpg";